import { render, staticRenderFns } from "./qxc_table.vue?vue&type=template&id=1ff86cb2&scoped=true"
import script from "./qxc_table.vue?vue&type=script&lang=js"
export * from "./qxc_table.vue?vue&type=script&lang=js"
import style0 from "./qxc_table.vue?vue&type=style&index=0&id=1ff86cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff86cb2",
  null
  
)

export default component.exports